import { useSelector } from 'react-redux';

export const useProgress = () => {
  const progress = useSelector((state) => state.progress);
  
  return {
    ...progress,
  };
};
